import { type ReactNode } from 'react';
import { Box, Paper } from '@mui/material';
import { Brand } from './Brand';

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', px: 2, py: 5 }}>
      <Box sx={{ width: '100%', maxWidth: 376 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}><Brand /></Box>
        <Paper
          elevation={1}
          sx={{
            mt: 3,
            p: 3,
            color: 'text.primary',
            backgroundColor: 'background.paper',
            border: '1px solid',
            borderColor: 'divider',
            backdropFilter: 'blur(14px)'
          }}
        >
          {children}
        </Paper>
      </Box>
    </Box>
  );
}
